import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logoFinal from '../../assets/logo_final.png';

// ─────────────────────────────────────────────────────────────────────────────
// ICONS — Professional FontAwesome-style SVG icons (no external dependency)
// ─────────────────────────────────────────────────────────────────────────────

const MapPinIcon = () => (
  <svg viewBox="0 0 384 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M172.3 501.7C27 291 0 269.4 0 192 0 86 86 0 192 0s192 86 192 192c0 77.4-27 99-172.3 309.7-9.5 13.8-29.9 13.8-39.4 0zM192 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"/>
  </svg>
);

const MailIcon = () => (
  <svg viewBox="0 0 512 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/>
  </svg>
);

const PhoneIcon = () => (
  <svg viewBox="0 0 512 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L184.3 167c13.7-11.1 18.4-30 11.6-46.3l-40-96z"/>
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 448 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M100.3 448H7.4V148.9h92.9V448zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/>
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 320 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M279.1 288l14.2-92.7h-88.9v-60.1c0-25.4 12.4-50.1 52.2-50.1h40.4V6.3S260.4 0 225.4 0c-73.2 0-121.1 44.4-121.1 124.7v70.6H22.9V288h81.4v224h100.2V288z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 448 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>
  </svg>
);

// ─────────────────────────────────────────────────────────────────────────────
// FOOTER DATA — Update contact info, links, and services here easily
// ─────────────────────────────────────────────────────────────────────────────

const QUICK_LINKS = [
  { label: 'Home',            href: '/' },
  { label: 'About Us',        href: '/about-us' },
  { label: 'Services',        href: '/' },
  { label: 'Projects',        href: '/projects' },
  { label: 'Contact Us',      href: '/contact-us' },
];

const SERVICES = [
  { label: 'Soil Investigation',                href: '/services/soil-investigation' },
  { label: 'Recharge / Relief Well',           href: '/services/recharge-well' },
  { label: 'Pumping Test',                     href: '/services/pumping-test' },
  { label: 'TAM Grouting',                     href: '/services/tam-grouting' },
  { label: 'Fissure Grouting',                 href: '/services/fissure-grouting' },
  { label: 'JET Grouting',                     href: '/services/jet-grouting' },
  { label: 'Instrumentation & Monitoring',     href: '/services/instrumentation' },
  { label: 'Pipe Jacking',     href: '/services/shaft-pipe' },
];

const CONTACT_ITEMS = [
  {
    icon: <MapPinIcon />,
    label: 'Address',
    value: '19 Veersamy Road, Singapore 207350',
    href: 'https://maps.google.com/?q=19+Veersamy+Road+Singapore+207350',
  },
  {
    icon: <MailIcon />,
    label: 'Email',
    value: 'info@gskgeotech.com',
    href: 'mailto:info@gskgeotech.com',
  },
  {
    icon: <PhoneIcon />,
    label: 'Phone — Nedu',
    value: '+65 9239 8494',
    href: 'tel:+6592398494',
  },
  {
    icon: <PhoneIcon />,
    label: 'Phone — Suben',
    value: '+65 9027 1160',
    href: 'tel:+6590271160',
  },
  {
    icon: <PhoneIcon />,
    label: 'Phone — Gopal',
    value: '+65 9067 4198',
    href: 'tel:+6590271160',
  },
];

// Certifications shown as mini badges under brand description
const CERT_BADGES = ['ISO 9001:2015', 'ISO 45001:2018', 'BizSAFE Star', 'CR15', 'CR12'];

// Social links — add/remove as needed; set href to '#' to hide
const SOCIALS = [
  { icon: <LinkedInIcon />, label: 'LinkedIn', href: '#' },
  { icon: <FacebookIcon />, label: 'Facebook', href: '#' },
  { icon: <InstagramIcon />, label: 'Instagram', href: '#' },
];

// Bottom bar legal links
const LEGAL_LINKS = [
  { label: 'Privacy Policy',  href: '/privacy' },
  { label: 'Terms of Use',    href: '/terms' },
];

// ─────────────────────────────────────────────────────────────────────────────
// Component
// ─────────────────────────────────────────────────────────────────────────────
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" id="contact">

      {/* ── Main Body ── */}
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-grid">

            {/* ── Col 1 : Brand ── */}
            <div className="footer-brand">
              <Link to="/" className="footer-logo">
                <img src={logoFinal} alt="GSK Geotech" className="footer-logo-img" />
                <div className="footer-logo-text">
                  <span className="footer-logo-name">GSK Geotech Pte Ltd</span>
                  <span className="footer-logo-tagline">Singapore</span>
                </div>
              </Link>

              <p className="footer-brand-desc">
                Your trusted partner in Geotechnical Engineering. We strive to
                ensure every project is executed safely and with the highest
                quality across Singapore.
              </p>

              <div className="footer-cert-badges">
                {CERT_BADGES.map((cert) => (
                  <span className="footer-cert-badge" key={cert}>{cert}</span>
                ))}
              </div>

              <div className="footer-socials">
                {SOCIALS.map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    className="footer-social-btn"
                    aria-label={s.label}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* ── Col 2 : Quick Links ── */}
            <div>
              <h4 className="footer-col-title">Quick Links</h4>
              <ul className="footer-links">
                {QUICK_LINKS.map((link) => (
                  <li key={link.label}>
                    <Link to={link.href}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* ── Col 3 : Services ── */}
            <div>
              <h4 className="footer-col-title">Our Services</h4>
              <ul className="footer-links">
                {SERVICES.map((s) => (
                  <li key={s.label}>
                    <Link to={s.href}>{s.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* ── Col 4 : Contact ── */}
            <div>
              <h4 className="footer-col-title">Contact Us</h4>
              <div className="footer-contact-list">
                {CONTACT_ITEMS.map((item) => (
                  <div className="footer-contact-item" key={item.label}>
                    <div className="footer-contact-icon">{item.icon}</div>
                    <div className="footer-contact-info">
                      <div className="footer-contact-label">{item.label}</div>
                      {item.href ? (
                        <a
                          href={item.href}
                          className="footer-contact-value"
                          target={item.href.startsWith('http') ? '_blank' : undefined}
                          rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                        >
                          {item.value}
                        </a>
                      ) : (
                        <span className="footer-contact-value">{item.value}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* ── Divider ── */}
      <hr className="footer-divider" />

      {/* ── Bottom Bar ── */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p className="footer-bottom-copy">
            © {currentYear} <strong>GSK Geotech Pte Ltd</strong>. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            {LEGAL_LINKS.map((link, i) => (
              <React.Fragment key={link.label}>
                {i > 0 && <span className="footer-bottom-sep" />}
                <Link to={link.href}>{link.label}</Link>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

    </footer>
  );
};

export default Footer;